<template>
  <div v-loading="initLoading">
<div class="ReportDetailPagePurchase" style="padding: 20px;width: 500px;background-color: #fafafa" >
<div style="font-size: 20px">
  <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
    <el-breadcrumb-item :to="{ path: '/console' }" >数据中心</el-breadcrumb-item>
    <el-breadcrumb-item :to="{ path: '/ReportDetailPagePurchase' }" >导购员名单</el-breadcrumb-item>
  </el-breadcrumb>
</div>
<div style="font-size: 25px;margin-top: 15px;">
  <p>导购员名单</p>
</div>
<div style="width: 500px; font-family: 宋体; font-size: 25px;font-weight: bold">
  <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" style=" margin-top: 30px" >
    <el-form-item label="供应商" prop="selectedSupplierIds">
      <el-select popper-class="el-select" v-model="ruleForm2.selectedSupplierIds" value-key="id" filterable multiple placeholder="请选择"  @change="supplierid()" style="width: 400px">
        <el-option
          v-for="(item) in user"
          :key="item.id"
          :label="item.name"
          :value='item'>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="区域" prop="selectRegionals">
      <el-select popper-class="el-select" v-model.number="ruleForm2.selectedRegionals" multiple style="width: 400px" value-key="id" @change="selectRegionalss" placeholder="可筛选，不筛选则导出全部" :disabled="ruleForm2.selectedSupplierIds != '' && ruleForm2.selectedSupplierIds.length === 1 ?false:true">
        <select-all-option v-model="ruleForm2.selectedRegionals" group-value="regionals" @change="selectRegionalss" :data="selectRegionals"/>
        <el-option-group
          v-for="group in selectRegionals"
          :key="group.name"
          :label="group.name">
          <el-option
            v-for="item in group.regionals"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-option-group>
      </el-select>
    </el-form-item>
    <el-form-item label="省份" prop="selectProvinces">
      <el-select popper-class="el-select" v-model.number="ruleForm2.selectedProvinces"  style="width: 400px" value-key="id"   multiple placeholder="可筛选，不筛选则导出全部" :disabled="ruleForm2.selectedRegionals != '' ?false:true">
        <select-all-option v-model="ruleForm2.selectedProvinces" group-value="children" :data="selectProvinces"/>
        <el-option-group
          v-for="group in selectProvinces"
          :key="group.name"
          :label="group.name">
          <el-option
            v-for="item in group.children"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-option-group>
      </el-select>
    </el-form-item>
    <el-form-item style="text-align: center">
      <div>
        <div style="float: left;width: 30%">
          <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="loading" @click="excel()">导出excel</el-button>
        </div>
      </div>

      <div>
        <div style="float: left;width: 40%">
          <el-button style="color: white; border-color: #FF6633; background-color: #FF6633"    @click="openDialogTable()" >打开在线表格</el-button>
        </div>
      </div>
      <div>
        <div style="float: left;width: 30%">
          <el-button style="color: white; border-color: #FF6633; background-color: #FF6633"    @click="centerDialogVisible = true" >批量预注册</el-button>
        </div>
      </div>
    </el-form-item>
    <el-form-item>


    </el-form-item>
  </el-form>
</div>
</div>

<!--    <el-button type="text" @click="dialogTableVisible = true">打开嵌套表格的 Dialog</el-button>-->
    <div></div>
    <el-dialog
      title="批量预注册"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <h1>批量预注册:</h1>
      <span>1、请先下载预注册模版</span>
      <br>
      <span>2、下载模板后，在模板基础上填写，勿新增或删除字段，每个空格须填写完整。</span>
      <br>
      <span>3、点击上传填写完成的预注册模版</span>
      <span slot="footer" class="dialog-footer">

                    <el-button style="color: #FF6633; border-color: #FF6633; " :loading="loading"
                               @click="importLabel">下载预注册模板
                    </el-button>



                  <el-button style="color: white; border-color: #FF6633; background-color: #FF6633" :loading="loading"   @click="uploadResult" >上传预注册模板</el-button>
                  <input type="file" ref="uploadResult" v-show="false" accept=".xls,.xlsx" @change="upLoadExcel"/>


<!--    <el-button @click="centerDialogVisible = false">取 消</el-button>-->
<!--    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>-->
  </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="导购员名单" class="salesTable" :visible.sync="dialogTableVisible" width="70%" >
      <div style="padding-left: 30px">
        <span>导购筛选：</span>
        <el-input
          v-model="search"
          size="mini"
          @input="() => this.currentPage2 = 1"
          placeholder="输入姓名或手机尾号搜索"
          style="width: 200px;padding-right: 10px"/>
        <el-button size="mini" @click="searchSale()">搜索汇总维度</el-button>
        <el-button size="mini" @click="clearSearch()" style="margin-left: 10px">重置</el-button>
      </div>
      <div style="padding-left: 30px;padding-top: 10px">
        <span>
          规则分配状态查询：
        </span>
        <el-radio-group v-model="ruleForm2.include" size="mini">
          <el-radio :label="1">包含</el-radio>
          <el-radio :label="2">不包含</el-radio>
        </el-radio-group>
        <el-select v-model="ruleForm2.packageId" size="mini" style="margin-left: 10px;width: 300px" clearable filterable placeholder="请选择规则">
          <el-option
            v-for="item in packages"
            :key="item.packageId"
            :label="item.packageName"
            :value="item.packageId">
          </el-option>
        </el-select>
        <el-button size="mini" @click="queryTable()" style="margin-left: 10px">查询</el-button>
        <el-button size="mini" @click="clearSearch()" style="margin-left: 10px">重置</el-button>
      </div>
      <el-table
        :data="filterData"
        :height="windowHeight/1.5"
        v-loading="tableLoading"
        style="width: 100%;padding-left: 30px">
        <el-table-column
          label="ID"
          prop="id"
        width="70">
        </el-table-column>
        <el-table-column
          label="姓名"
          prop="name"
          width="70">
        </el-table-column>
        <el-table-column
          label="信用等级"
          prop="credit_class"
          width="90">
        </el-table-column>
        <el-table-column
          label="手机号"
          prop="phone"
          width="100">
        </el-table-column>
        <el-table-column
          label="省份"
          prop="province"
          width="70">
        </el-table-column>
        <el-table-column
          label="城市"
          prop="city"
          width="70">
        </el-table-column>
        <el-table-column
          label="区县"
          prop="district"
          width="80">
        </el-table-column>
        <el-table-column
          label="连锁品牌"
          prop="brand"
          width="100">
        </el-table-column>
        <el-table-column
          label="门店名称"
          prop="store_name"
          width="150"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="地址"
          prop="address"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="签约业务员"
          prop="manager"
          width="100">
        </el-table-column>
        <el-table-column
          label="业务员手机号"
          prop="manager_phone"
          width="120">
        </el-table-column>
        <el-table-column
          label="签约时间"
          prop="create_time"
          width="150">
        </el-table-column>
        <el-table-column
          label="签约方式"
          prop="register_time"
          width="90">
        </el-table-column>
        <el-table-column
          label="上次登录时间"
          prop="login_time"
        width="150">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="查看"
          width="120">
          <template slot-scope="scope">
            <el-popover
              placement="right"
              width="200"
              trigger="click">
              <el-table :data="scope.row.extras">
                <el-table-column width="100" property="name" label="标签名"></el-table-column>
                <el-table-column width="100" property="value"  label="标签值"></el-table-column>
              </el-table>
              <el-button slot="reference" >标签</el-button>
            </el-popover>
            <el-popover
              placement="bottom-end"
              width="600"
              trigger="click">
              <el-table :data="packageData" v-loading="packageLoading">
                <el-table-column width="100" property="parent_brand" label="品牌"></el-table-column>
                <el-table-column width="200" property="package_name"  label="规则"></el-table-column>
                <el-table-column width="300" property="package"  label="范围"></el-table-column>
              </el-table>
              <el-button slot="reference" @click="getPackageInfo(scope.row)" >规则</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <!--      <el-table-column-->
        <!--        label="伊迪旺-连锁名称"-->
        <!--        prop="extras[0].value">-->
        <!--      </el-table-column>-->
<!--        <el-table-column-->
<!--          align="right">-->
<!--          -->
<!--          &lt;!&ndash;          <template slot-scope="scope">&ndash;&gt;-->
<!--          &lt;!&ndash;            <el-button&ndash;&gt;-->
<!--          &lt;!&ndash;              size="mini"&ndash;&gt;-->
<!--          &lt;!&ndash;              @click="handleEdit(scope.$index, scope.row)">Edit</el-button>&ndash;&gt;-->
<!--          &lt;!&ndash;            <el-button&ndash;&gt;-->
<!--          &lt;!&ndash;              size="mini"&ndash;&gt;-->
<!--          &lt;!&ndash;              type="danger"&ndash;&gt;-->
<!--          &lt;!&ndash;              @click="handleDelete(scope.$index, scope.row)">Delete</el-button>&ndash;&gt;-->
<!--          &lt;!&ndash;          </template>&ndash;&gt;-->
<!--        </el-table-column>-->
      </el-table>
      <div style="text-align: center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage2"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="currentPageSize"
          layout="sizes, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { allUser } from '@/api/ReportDetailPage'
import {excelPurchase, importLabel, putExcel, putExtraExcel,importLabelPre,querySales,queryPackageInfo} from '@/api/ReportDetailPagePurchase'
import selectAllOption from "@/components/selectAllOption";
export default {
  components: {selectAllOption},
  data () {
    return {
      ruleForm2: {
        selectedSupplierIds: '',
        selectedRegionals: '',
        selectedProvinces: '',
        // 1包含 2不包含
        include: 1,
        //1 一个 2 任意
        packageId: null
      },
      // 判断供应商是否选择
      rules2: {
        selectedSupplierIds: [
          { required: true, message: '请至少选择一个供应商', trigger: 'change' }
        ]
      },
      user: [],
      value: '',
      selectRegionals: [],
      selectProvinces: [],
      token: '',
      loading: false,
      userSupplierId:'',
      initLoading:true,
      tableData: [],
      search: '',
      dialogTableVisible: false,
      currentPage2:1,
      total:100,
      currentPageSize:100,
      centerDialogVisible: false,
      tableLoading:true,
      packageData:[],
      packageLoading:false,
      searchFlag:false,
      windowHeight: window.innerHeight,
      packages:[{packageId:'all',packageName:'任意规则'}]
    }
  },
  created () {
    // 进入测页面以后 查询出下拉框的所有值
    this.allUser()
    this.userSupplierId = localStorage.getItem("userSupplierId");
    this.$store.commit('addTips',['大部分字段可选择性填写，若不填写则表示导出全部。可选填的字段包括[区域]、[省份]'])

  },
  computed: {
    filterData() {
      let tableData = this.tableData.filter(data => !this.search || (this.searchFlag?data:data.name.toLowerCase().includes(this.search.toLowerCase())||data.phone.toLowerCase().includes(this.search.toLowerCase())))
      this.total = tableData.length
      tableData = tableData.slice((this.currentPage2-1)*this.currentPageSize,this.currentPage2*this.currentPageSize)
      return tableData
    }
  },
  methods: {
    supplierid () {
      // 根据选择的供应商赋值给品牌和区域
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds != '') {
        // if (this.ruleForm2.selectedSupplierIds.length > 1) {
        //   this.ruleForm2.selectedSupplierIds.splice(1, 1)
        //   this.$notify({
        //     title: '警告',
        //     message: '只能选择一个供应商',
        //     type: 'warning',
        //     position: 'bottom-right'
        //   })
        // }
        this.selectRegionals = this.ruleForm2.selectedSupplierIds
      } else {
        this.ruleForm2.selectedRegionals = []
        this.ruleForm2.selectedProvinces = []
      }
    },
    selectRegionalss () {
      // 根据选择的区域赋值给不同的省份
      this.selectProvinces = this.ruleForm2.selectedRegionals
    },
    allUser () {
      this.token = localStorage.getItem('token')
      allUser(this.token,localStorage.getItem('dashboardSales') == 1 ? null : localStorage.getItem('userSupplierId')).then(res => {
        if (res.data.suppliers != null) {
          this.user = res.data.suppliers
          if (this.user.length == 1){
            this.ruleForm2.selectedSupplierIds = this.user
            this.supplierid();
          }
        }
        this.initLoading = false;
      }).catch(error => {
        let status = error.response.status;
        if (status == 500){
          this.$notify.error({
            title: '错误',
            message: '查询失败，请联系管理员',
            position: 'bottom-right'
          })
        }
      })
    },
    excel () {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds != '') {
        this.token = localStorage.getItem('token')
        // eslint-disable-next-line eqeqeq
        if (this.ruleForm2.selectedBrands != '') {
        } else {
          this.ruleForm2.selectedBrands = this.ruleForm2.selectedParentBrands
        }
        this.loading = true
        excelPurchase(this.token, this.ruleForm2,localStorage.getItem('managerId')).then(res => {
          if (res && res.data) {
            window.location.href = res.data.date;
            this.$notify({
              type: 'success',
              message: '导出成功',
              title: '成功',
              position: 'bottom-right'
            })
            this.loading = false
          }
        }).catch(error => {
          let status = error.response.status;
          if (status == 500){
            this.$notify({
              title: '错误',
              message: '导出错误，请及时联系管理员',
              type: 'error',
              position: 'bottom-right'
            })
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    handleDownload (res) {
      console.log(res)
      // 创建下载的链接
      // 设置该文件的mime类型，这里对应的mime类型对应为.xlsx格式
      let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    uploadResult() {
      if (this.ruleForm2.selectedSupplierIds.length < 1) {
        this.$notify({
          title: '警告',
          message: '请选择至少一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
        return
      }
      this.supplierId = this.ruleForm2.selectedSupplierIds[0].id
      this.$refs.uploadResult.click()
    },
    upLoadExcel() {
      this.loading = true
      let inputDOM = this.$refs.uploadResult
      let file = inputDOM.files[0]
      let formData = new FormData();
      formData.append("file", file)
      putExcel(this.token, this.supplierId, formData).then(r => {
        let {data} = r
        if (data.code == 200)
          this.successMsg = data.date

        if (data.code == 1){
          this.$alert(data.date, data.msg, {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
            callback: action => {
              // this.$message({
              //   type: 'info',
              //   message: `action: ${ action }`
              // });
            }
          });
        }else {
          this.$alert(data.date, data.msg, {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: action => {
              // this.$message({
              //   type: 'info',
              //   message: `action: ${ action }`
              // });
            }
          });
        }

      }).catch(error => {
        let status = error.response.status;
        if (status == 500) {
          this.$notify.error({
            title: '错误',
            message: '请联系管理员',
            position: 'bottom-right'
          })
        }
      }).finally(() => {
        this.queryTable()
        this.loading = false
        this.$refs.uploadResult.value = ''
      })
    },
    importLabel() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm2.selectedSupplierIds != '') {
        this.token = localStorage.getItem('token')
        // eslint-disable-next-line eqeqeq
        if (this.ruleForm2.selectedBrands == '') {
          this.ruleForm2.selectedBrands = this.ruleForm2.selectedParentBrands
        }
        this.loading = true
        importLabelPre(this.token, this.ruleForm2).then(res => {
          if (res !== null) {
            this.$notify({
              type: 'success',
              message: '导出成功',
              title: '成功',
              position: 'bottom-right'
            })
            this.handleDownload(res)
            this.loading = false
          }
        }).catch(error => {
          let status = error.response.status;
          if (status == 500) {
            this.$notify({
              title: '错误',
              message: '导出错误，请及时联系管理员',
              type: 'error',
              position: 'bottom-right'
            })
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$notify({
          title: '警告',
          message: '请至少选择一个供应商',
          type: 'warning',
          position: 'bottom-right'
        })
      }
    },
    queryTable(){
      this.tableLoading=true
      this.ruleForm2.page=(this.currentPage2-1)*this.currentPageSize
      this.ruleForm2.pageSize=this.currentPageSize
      if (this.search){
        this.ruleForm2.propValue = this.search
      }else{
        this.ruleForm2.propValue = null
      }
      querySales(this.token, this.ruleForm2).then(r => {
        this.tableData = r.data.data.list.map(it=>{
          if (it.remark && it.remark.indexOf("预注册") >= 0) {
            it.register_time='预注册上传'
          } else {
            it.register_time = '扫码注册'
          }
          return it
        })
        this.total = r.data.data.total
        this.packages = [{packageId:'all',packageName:'任意规则'}].concat(r.data.data.packages)
      }).catch(error => {

      }).finally(() => {
        this.tableLoading=false
      })
    },
    handleSizeChange(val) {
      this.currentPage2 = 1
      this.currentPageSize = val
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage2 = val
      console.log(`当前页: ${val}`);
    },
    openDialogTable(){
      this.ruleForm2.packageId = null
      this.ruleForm2.include =1
      this.dialogTableVisible = true
      this.search = null
      this.searchFlag=false
      this.tableData = []
      this.queryTable()
    },
    getPackageInfo(aa){
      this.packageData = [];
      this.packageLoading = true
      let data = {"saleId":aa.id,"supplierId":this.ruleForm2.selectedSupplierIds[0].id}
      queryPackageInfo(this.token, data).then(r => {
        console.log(r)
        this.packageData = r.data.data.list
      }).catch(error => {

      }).finally(() => {
        this.packageLoading = false
      })
    },
    searchSale(){
      if (this.search.length<2){
        this.$notify.error({
          title: '错误',
          message: '请至少输入两个关键字',
          position: 'bottom-right'
        })
        return
      }else {
        this.searchFlag=true
        this.queryTable()
      }
    },
    clearSearch(){
      this.search = ''
      this.searchFlag=false
      this.ruleForm2.include = 1
      this.ruleForm2.packageId = null
      this.queryTable()
    }
  }
}
</script>

<style scoped>
.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.salesTable >>> .el-dialog {
  margin-top: 7vh !important;
}

.salesTable >>> .el-radio {
  margin-right: 10px;
}
.salesTable >>> .el-radio:last-child {
  margin-right: 0;
}

.salesTable >>> .el-dialog__body {
  padding-top: 10px;
}
</style>
